import { hub } from "../hub";
import { TVContext, tvbar } from "../hub/context";
import { color_transparent, getColor, halign_right, hrTool, tvpoint, valign_bottom, valign_top, vlTool } from "../tv";
import { SyncerUpdateType, TVSyncer } from "./sync";
import { SyncerChange, TVSyncerTool } from "./syncitem";
import { TimeFrameHelper } from "../hub/timeframe";
import { BarData } from "../hub/datafeed";
import { DateTime } from "../hub/datetime";
import { TimeFrame } from "../config/tickers";

export class crossHairTool {
	tvd: TVContext;
	vert: vlTool;
	horz: hrTool;
	sync: boolean;
	constructor(tv: TVContext) {
		this.tvd = tv;
		this.vert = new vlTool(this.tvd, null, 1, false, 2);
		this.horz = new hrTool(this.tvd, null, 1, false, 2);
		this.vert.setAligns(valign_bottom, halign_right);
		this.updateView();
	}

	updateView(init = false) {
		const color = getColor(hub.tvConfig.paneProperties.crossHairProperties.color);
		this.sync = hub.tvConfig.paneProperties.crossHairProperties.sync;
		if (init) {
			this.vert.clear();
			this.horz.clear();
		}
		this.vert.setColor(color, color);
		this.horz.setColor(color, color);
		if (!this.sync) {
			this.vert.clear();
			this.horz.clear();
		}
	}
	clear() {
		this.vert.clear();
		this.horz.clear();
	}
	build(isme: boolean, tid: string, p: tvpoint, ptf: TimeFrame) {
		if (!this.sync)
			return;
		if (isme) {
			if (!this.vert.isVisible)
				return;
			this.horz.clear();
			this.vert.clear();
		} else {
			const ctf = this.tvd.getTimeFrameInfo();
			if (ptf.o < ctf.o && p.t * 1000 >= this.tvd.lastRecord)
				this.vert.build({
					t: TimeFrameHelper.adjustTVTime(this.tvd, p.t, ptf),
					p: p.p
				});
			else
				this.vert.build(p);
			const ctid = this.tvd.tid;
			if (ctid == tid) {
				const timeRange = this.tvd.tv.activeChart().getVisibleRange();
				this.horz.build({
					t: timeRange.from,
					p: p.p
				});
			}
			else {
				this.horz.clear();
			}
		}
	}
}
export class CrossHairSync extends TVSyncerTool {
	crossHair: crossHairTool;
	private lastBarAt: number;
	private lastBar: BarData;
	constructor(syncer: TVSyncer, tvd: TVContext) {
		super(syncer, tvd);
	}
	override onEndChange(type: SyncerChange) {
		if (type != SyncerChange.Symbol)
			return;
		this.crossHair.clear();
		let bar: BarData = null;
		const bars = this.tvd.bars;
		if (bars.length > 0)
			bar = bars[bars.length - 1];
		this.tvd.setCrossHairBar(bar);
		this.lastBarAt = bar?.t;
	}
	static convertToUtc(tvd: TVContext, p: TradingView.PricedPoint) {
		//let tzoff = 0;
		const tf = hub.tfs.get(tvd.tf);
		//if (tf?.t < TimeFrameType.Day)
		//	tzoff = tvd.tv.activeChart().getTimezoneApi().getTimezone().offset;
		//if (tzoff == null)
		//	tzoff = 0;
		//const pt = {
		//	t: (p.time * 1000 - tzoff) / 1000,
		//	p: p.price
		//};
		const pt = {
			t: p.time,
			p: p.price
		};
		return { pt, tf };
	}
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	override onInit() {
		this.crossHair = new crossHairTool(this.tvd);
		this.tvd.tv.activeChart().crossHairMoved().subscribe(
			null,
			(p: TradingView.PricedPoint) => {
				try {
					const tid = this.tvd.tv.activeChart().symbol();
					const pt = CrossHairSync.convertToUtc(this.tvd, p);
					const cur = this.syncer.items[this.tvd.id]?.crossHair as CrossHairSync;
					try {
						cur?.build(null, true, tid, pt.pt, pt.tf);
					} catch (e) {
						cur.clear();
						console.warn('tv' + this.tvd.id + ': ' + e);
					}

					for (let i = 0; i < hub.count; i++) {
						if (this.tvd.id == i)
							continue;
						const ch = this.syncer.items[i]?.crossHair as CrossHairSync;
						try {
							ch?.build(cur?.lastBar, false, tid, pt.pt, pt.tf);
						} catch (e) {
							ch.clear();
							console.warn('tv' + i + ': ' + e);
						}
					}
				} catch (e) { console.warn('tv' + this.tvd.id + ': ' + e); }
			}
		);
	}
	build(myBar: BarData, isme: boolean, tid: string, p: tvpoint, ptf: TimeFrame) {
		if (!this.crossHair)
			return;
		if (this.lastBarAt != p.t) {
			this.lastBar = this.tvd.getBarByTime(p.t);
			if (this.lastBar == null)
				this.lastBar = myBar;
			this.tvd.setCrossHairBar(this.lastBar);
			this.lastBarAt = p.t;
		}
		this.crossHair.build(myBar == null, tid, p, ptf);
	}
	override updateView(init: boolean) {
		if (this.crossHair)
			this.crossHair.updateView(init);
		if (!hub.tvConfig.paneProperties.crossHairProperties.sync) {
			this.tvd.setCrossHairBar(null);
			this.lastBarAt = null;
		}
	}

	override clear() {
		this.crossHair?.clear();
	}
}
